/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 */
import { orvalMutator } from "../config/orval/orvalMutator";

import type {
    GetApiInternalNotifications200,
    GetApiInternalNotificationsParams,
    ModelsLoginRequest,
    ModelsPasswordResetConfirmRequest,
    ModelsPasswordResetRequest,
    ModelsReadNotificationsRequest,
    ModelsRefreshTokenRequest,
    ModelsUpdateUserPasswordRequest,
    PatchApiInternalNotifications200,
    PatchApiInternalUserPassword200,
    PostApiInternalLogin200,
    PostApiInternalPasswordReset200,
    PostApiInternalPasswordResetConfirm200,
    PostApiInternalRefreshToken200,
} from "../../schemas";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Login
 * @summary Login
 */
export const postApiInternalLogin = (
    modelsLoginRequest: ModelsLoginRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalLogin200>(
        {
            url: `/api/internal/login`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsLoginRequest,
        },
        options,
    );
};
/**
 * Get user notifications
 * @summary Get user notifications
 */
export const getApiInternalNotifications = (
    params: GetApiInternalNotificationsParams,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<GetApiInternalNotifications200>(
        { url: `/api/internal/notifications`, method: "GET", params },
        options,
    );
};
/**
 * Read notifications
 * @summary Read notifications
 */
export const patchApiInternalNotifications = (
    modelsReadNotificationsRequest: ModelsReadNotificationsRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PatchApiInternalNotifications200>(
        {
            url: `/api/internal/notifications`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: modelsReadNotificationsRequest,
        },
        options,
    );
};
/**
 * RequestPasswordReset
 * @summary RequestPasswordReset
 */
export const postApiInternalPasswordReset = (
    modelsPasswordResetRequest: ModelsPasswordResetRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalPasswordReset200>(
        {
            url: `/api/internal/password_reset`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsPasswordResetRequest,
        },
        options,
    );
};
/**
 * ConfirmPasswordReset
 * @summary ConfirmPasswordReset
 */
export const postApiInternalPasswordResetConfirm = (
    modelsPasswordResetConfirmRequest: ModelsPasswordResetConfirmRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalPasswordResetConfirm200>(
        {
            url: `/api/internal/password_reset/confirm`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsPasswordResetConfirmRequest,
        },
        options,
    );
};
/**
 * RefreshToken
 * @summary RefreshToken
 */
export const postApiInternalRefreshToken = (
    modelsRefreshTokenRequest: ModelsRefreshTokenRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PostApiInternalRefreshToken200>(
        {
            url: `/api/internal/refresh_token`,
            method: "POST",
            headers: { "Content-Type": "application/json" },
            data: modelsRefreshTokenRequest,
        },
        options,
    );
};
/**
 * Update user password
 * @summary Update user password
 */
export const patchApiInternalUserPassword = (
    modelsUpdateUserPasswordRequest: ModelsUpdateUserPasswordRequest,
    options?: SecondParameter<typeof orvalMutator>,
) => {
    return orvalMutator<PatchApiInternalUserPassword200>(
        {
            url: `/api/internal/user/password`,
            method: "PATCH",
            headers: { "Content-Type": "application/json" },
            data: modelsUpdateUserPasswordRequest,
        },
        options,
    );
};
export type PostApiInternalLoginResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalLogin>>
>;
export type GetApiInternalNotificationsResult = NonNullable<
    Awaited<ReturnType<typeof getApiInternalNotifications>>
>;
export type PatchApiInternalNotificationsResult = NonNullable<
    Awaited<ReturnType<typeof patchApiInternalNotifications>>
>;
export type PostApiInternalPasswordResetResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalPasswordReset>>
>;
export type PostApiInternalPasswordResetConfirmResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalPasswordResetConfirm>>
>;
export type PostApiInternalRefreshTokenResult = NonNullable<
    Awaited<ReturnType<typeof postApiInternalRefreshToken>>
>;
export type PatchApiInternalUserPasswordResult = NonNullable<
    Awaited<ReturnType<typeof patchApiInternalUserPassword>>
>;
